import { dateToGpsWeek } from '@/components/common/dateUtils';

export type CNetPublicationIdentity = {
	cnet_number: number;
	gps_week: number;
	gridpoint_count: number;
};

export const sortCnetNumbersWithCurrentWeekLast = (
	numbers: number[],
	currentWeekPublishedCnetNumbers: number[],
): number[] => {
	const publishedSet = new Set(currentWeekPublishedCnetNumbers);
	const preferred = numbers.filter(number => !publishedSet.has(number));
	const deprioritized = numbers.filter(number => publishedSet.has(number));
	return [...preferred.sort((left, right) => left - right), ...deprioritized.sort((left, right) => left - right)];
};

export const shouldShowCnetCacheWarning = (
	cnetNumber: number | null | undefined,
	weekDate: string | null | undefined,
	gridpointCount: number | null | undefined,
	publications: CNetPublicationIdentity[],
): boolean => {
	if (cnetNumber == null || weekDate == null || gridpointCount == null) {
		return false;
	}
	const gpsWeek = dateToGpsWeek(weekDate);
	return publications.some(publication => (
		publication.cnet_number === cnetNumber
		&& publication.gps_week === gpsWeek
		&& publication.gridpoint_count === gridpointCount
	));
};
